var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"bottomup"}},[(_vm.showGoToTop)?_c('b-button',{staticClass:"button mdi mdi-chevron-double-up mdi-36px unPrintTarget",attrs:{"id":"page_top","type":"is-primary"},on:{"click":_vm.goToTop}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c2ce4f0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mock/base/pageTop.vue
// module id = null
// module chunks = 